/**
 * Один вопрос об имени на весь экран.
 *
 * Неоднозначное имя — это вопрос, а не ответ: «Азарова» подходит и Юле, и
 * Юлии, и выбрать должен человек. Кандидаты кнопками, чтобы выбор был явным.
 */

import type { Conflict, FilterState } from "../api/types";
import { useConflicts } from "../state/conflicts";
import { useStore } from "../state/store";

const FIELD_NAMES: Record<Conflict["field"], string> = {
  person: "человек",
  person_b: "второй человек",
  program: "программа",
};

export function ConflictBanner() {
  const { conflicts } = useConflicts();
  const { patch } = useStore();
  if (conflicts.length === 0) return null;

  return (
    <div className="banner">
      {conflicts.map((conflict) => (
        <div className="banner__item" key={`${conflict.field}:${conflict.query}`}>
          <p className="banner__text">
            <strong>{FIELD_NAMES[conflict.field]}:</strong> {conflict.message}
          </p>
          {conflict.ambiguous ? (
            <div className="needs__choices">
              {conflict.candidates.map((candidate) => (
                <button
                  type="button"
                  className="button button--ghost"
                  key={candidate}
                  onClick={() => patch({ [conflict.field]: candidate } as Partial<FilterState>)}
                >
                  {candidate}
                </button>
              ))}
            </div>
          ) : (
            <button
              type="button"
              className="button button--ghost"
              onClick={() => patch({ [conflict.field]: null } as Partial<FilterState>)}
            >
              Снять фильтр
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
